export const PROPOSAL_QUOTATION_ROI_CALCULATE =
  'proposal/quotation/roi/calculate'
